<template>
  <f7-page id="page-fx-calculator" name="fx-calculator" @page:beforein="beforein" @page:afterin="afterin" @page:beforeout="handleBeforeOut()">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
					<f7-link @click="backButton" color="black"><i class="f7-icons">chevron_left</i></f7-link>
				</f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <f7-row>
        <f7-col class="wandr-level-2">{{$t('fx-label-calculator')}}</f7-col>
      </f7-row>

      <!-- EXCHANGE RATE CALCULATOR COMPONENT -->
      <ExchangeRateCalculator class="mb-xl" isExchangeView="true" v-if="loadFxRate" />
    </f7-block>

  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex"
  // import ExchangeRateCalculator from '@/components/exchange-rate-calculator'

  export default {
    components: {
      ExchangeRateCalculator      : () => import('../../components/exchange-rate-calculator.vue'),
    },
    computed: {
      ...mapGetters('auth', [
        'authenticating',
        'authenticationError',
        'authenticationErrorCode',
        'authenticationSuccess'
      ])
    },
    data() {
      return {
        loadFxRate            : false
      }
    },
    mounted() {
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
    },
    methods: {
      ...mapActions('auth', ['login']),

      beforein(){
        this.loadFxRate = true
      },

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      backButton(){
        this.setInputState("fx-host-amount", true)
        this.setInputState("fx-home-amount", true)
        this.setInputState("fx-calc-home-amount", true)
        this.setInputState("fx-calc-host-amount", true)
        this.$f7router.back({force: true})
      },

      handleBeforeOut(){
        this.loadFxRate = false
      }
    }
  }
</script>